import { createSelector } from 'reselect';

import { convertListToObjectBy } from 'utils/fn';

import { __getCommonData } from '../../selectors';
import { AB_TEST_TRUE } from './constants';
// import { getValueOfCookie } from '../settings/selectors';

/** Base Data selector, all the other selectors must use it */
export const getABTestsData = (state) => __getCommonData(state).ab || {};

export const getABTestsList = (state) => getABTestsData(state).tests || [];
export const getPageHasABTests = (state) => getABTestsList(state).length !== 0;

export const getABTestsDict = createSelector(getABTestsList, convertListToObjectBy('key'));

export const getABTestDataBySlug = (state, slug) => getABTestsDict(state)[slug] || {};

export const getABTestExist = (state, slug) => !!getABTestsDict(state)[slug];

export const getABTestValue = (state, slug) => getABTestDataBySlug(state, slug).value || '';
export const getIsABTestEnabled = (state, slug) => getABTestValue(state, slug) === AB_TEST_TRUE;
